import { render, staticRenderFns } from "./EcgAnalyze.vue?vue&type=template&id=070c578c&scoped=true&"
import script from "./EcgAnalyze.vue?vue&type=script&lang=js&"
export * from "./EcgAnalyze.vue?vue&type=script&lang=js&"
import style0 from "./EcgAnalyze.vue?vue&type=style&index=0&id=070c578c&lang=less&scoped=true&"
import style1 from "./EcgAnalyze.vue?vue&type=style&index=1&id=070c578c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070c578c",
  null
  
)

export default component.exports